/**
 * Represents the environment types that exist for this project.
 * 
 * @enum
 */
export const Environment = {
    UNKNOWN: 'unknown',
    LOCAL: 'localhost',
    DEV: 'dev',
    QA: 'qa',
    PPRD: 'pprd',
    PROD: 'prod',
};

/**
 * Returns whether or not the provided environment value is considered to be
 * valid. The only environments currently considered to be valid are dev, qa,
 * pprd, and prod.
 * 
 * @param { string } env - The environment value to check.
 * @returns { boolean }
 */
export function isValidEnv( env ) {
    switch ( env ) {
        case Environment.DEV:
        case Environment.QA:
        case Environment.PPRD:
        case Environment.PROD: {
            return true;
        }
        default: {
            return false;
        }
    }
}

/**
 * Given an environment value, a valid environment will be returned that most
 * closely matches the provided environment. The returned environment may or
 * may not be exactly the same as the environment provided.
 * 
 * @param { string } env - The environment to convert.
 * @returns { string }
 */
export function convertToValidEnv( env ) {
    switch ( env ) {
        case Environment.DEV: {
            return Environment.DEV;
        }
        case Environment.PPRD: {
            return Environment.PPRD;
        }
        case Environment.PROD: {
            return Environment.PROD;
        }
        default: {
            return Environment.QA;
        }
    }
}
